module.exports = __webpack_public_path__ + "static/media/lizhishenpibiao1.74173a38.png";